import { SET_CHOSEN_PLAN, SET_PLAN, SET_PLANS } from "@/store/constants/checkout";
import { SET_MIGRATION_RESULT } from "@/store/constants/migration";

export default {
    [SET_PLAN]: (state, plan) => state.plan = plan,
    [SET_CHOSEN_PLAN]: (state, chosenPlan) => state.chosenPlan = chosenPlan,
    [SET_PLANS]: (state, plans) => state.plans = plans,
    [SET_MIGRATION_RESULT]: (state, result) => state.migrationResult = result,
}